import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MenuItem from "./MenuItem";

import HomeSidebarIcon from "../../assets/Sidebar-Icons/Home-icon.svg";
import MasterIcon from "../../assets/Sidebar-Icons/master-icon.svg";
import LogsIcon from "../../assets/Sidebar-Icons/logs-icon.svg";
import ReportIcon from "../../assets/Sidebar-Icons/report-icon.svg";
import ApiIcon from "../../assets/Sidebar-Icons/Api Key.svg";
import WalletIcon from "../../assets/Sidebar-Icons/Wallet-icon.svg";
import SettingIcon from "../../assets/Sidebar-Icons/Setting.svg";
import HomeMainIcon from "../../assets/Sidebar-Icons/Home-s-icon.svg";
import SidebarBackIcon from "../../assets/Sidebar-Icons/Back Button.svg";
import LogoutIcon from "../../assets/Sidebar-Icons/Logout.png";
import ManageUserIcon from "../../assets/Sidebar-Icons/Manage-users-icon.svg";
import SupportCenterIcon from "../../assets/Sidebar-Icons/Support-Center-icon.svg";
import { openSidebar, toggleSidebar } from "../store/toggleSidebar";
import LogoutModal from "../logout/LogoutModal";
import { getInitial } from "../../helpers/helper";

const NewSidebar = () => {
  const [selectedMenu, setSelectedMenu] = useState("Home");
  const [showModal, setShowModal] = useState(false);
  const isSidebarOpen = useSelector((state) => state.sidebar.isSidebarOpen);
  const dispatch = useDispatch();

  const userData = useSelector((state) => state.auth);
  const backendMenu = userData?.menu;

  const array =
    backendMenu && backendMenu.length > 0
      ? backendMenu.split("").map((char) => parseInt(char, 10))
      : [];

  const userRole = sessionStorage.getItem("userRole");
  const canViewOtpEnquiries = userRole === "ADMK" || userRole === "ADCH";

  const menuItems = [
    {
      name: "Home",
      icon: HomeSidebarIcon,
      arr: array[0] === 1,
      submenu: [
        {
          label: "Dashboard",
          path: "/dashboard",
          arr: array[0] === 1,
        },
      ],
    },
    {
      name: "Master",
      icon: MasterIcon,
      arr: array[0] === 1,
      submenu: [
        {
          label: "User Master",
          path: "/userMaster",
          arr: array[1] === 1,
        },
        {
          label: "Franchise Master",
          path: "/FranchiseOnboarding",
          arr: array[116] === 1,
        },
        {
          label: "LMBP Master",
          path: "/CustomerOnboarding",
          arr: array[11] === 1,
        },
        {
          label: "Courier Hub",
          path: "/CourierHub",
          arr: array[88] === 1,
        },
        {
          label: "Vendor Master",
          path: "/vendorMaster",
          arr: array[6] === 1,
        },
        {
          label: "Stationary Master",
          path: "/stationaryMaster",
          arr: array[128] === 1,
        },
        {
          label: "Buy Stationary",
          path: "/buyStationaryMaster",
          arr: array[131] === 1,
        },
        {
          label: "Courier Master",
          path: "/courierCompanyOnboarding",
          arr: array[61] === 1,
        },
        {
          label: "Pickup Address",
          path: "/pickuporder",
          arr: array[77] === 1,
        },
        {
          label: "Order Master",
          path: "/orderMaster",
          arr: array[66] === 1,
        },
        {
          label: "Role Master",
          path: "/roleMaster",
          arr: array[31] === 1,
        },
        {
          label: "Bag Master",
          path: "/bag",
          arr: array[44] === 1,
        },
        {
          label: "Bag Master",
          path: "/bagCourier",
          arr: array[49] === 1,
        },
        {
          label: "Order",
          path: "/orderCourier",
          arr: array[60] === 1,
        },
        {
          label: "Notification Master",
          path: "/notificationMaster",
          arr: array[86] === 1,
        },
        {
          label: "Notification Master",
          path: "/notificationMasterHub",
          arr: array[87] === 1,
        },
        {
          label: "Delivery Master",
          path: "/deliveryMaster",
          arr: array[110] === 1,
        },
        {
          label: "Rate Card Master",
          path: "/rateCardMaster",
          arr: array[139] === 1,
        },
        {
          label: "Charges Master",
          path: "/chargesMaster",
          arr: array[95] === 1,
        },
        {
          label: "Charges Master New",
          path: "/chargesMasterNew",
          arr: array[95] === 1,
        },
        {
          label: "Pincode Serviceability",
          path: "/pincodeServiceability",
          arr: array[100] === 1,
        },
        {
          label: "Rate Calculator",
          path: "/rateCalculator",
          arr: array[105] === 1,
        },
        {
          label: "LMBP Rate Calculator",
          path: "/lmbpRateCalculator",
          arr: array[127] === 1,
        },
        {
          label: "Generate Sticker",
          path: "/generateSticker",
          arr: array[123] === 1,
        },
        {
          label: "Payment History",
          path: "/paymentHistory",
          arr: array[138] === 1,
        },
      ],
    },
    {
      name: "Logs",
      icon: LogsIcon,
      arr: array[0] === 1,
      submenu: [
        // {
        //   label: "Customer SMS Logs",
        //   path: "/smstransaction",
        //   arr: array[25] === 1,
        // },
        // {
        //   label: "Customer RCS Logs",
        //   path: "/rcstransaction",
        //   arr: array[26] === 1,
        // },
        // {
        //   label: "System SMS Logs",
        //   path: "/smsmaster",
        //   arr: array[30] === 1,
        // },
        // {
        //   label: "Vendor History",
        //   path: "/vendortxnhistory",
        //   arr: array[41] === 1,
        // },
      ],
    },
    {
      name: "Report",
      icon: ReportIcon,
      arr: array[0] === 1,
      submenu: [
        // {
        //   label: "Recharge/BBPS",
        //   path: "/transactionReport",
        //   arr: array[60] === 1,
        // },
        // {
        //   label: "Ledger",
        //   path: "/ledger",
        //   arr: array[67] === 1,
        // },
        {
          label: "Ledger Report",
          path: "/ledgerReport",
          arr: array[67] === 1,
        },
        {
          label: "Report Courier",
          path: "/reportCourier",
          arr: array[24] === 1,
        },
        {
          label: "Order Master",
          path: "/reportOrderMaster",
          arr: array[66] === 1,
        },
        {
          label: "Statement",
          path: "/statement",
          arr: array[126] === 1,
        },
        {
          label: "Upload Card RAW File",
          path: "/rawFileUpload",
          arr: array[135] === 1,
        },
      ],
    },
    {
      name: "API Document",
      icon: ApiIcon,
      arr: array[0] === 1,
      submenu: [
        {
          label: "API Document",
          path: "https://documenter.getpostman.com/view/19785617/2sB2xCi9ZX",
          arr: array[24] === 1,
        },
      ],
    },
    // {
    //   name: "Message Type",
    //   icon: MessageTypeIcon,
    //   arr: array[0] === 1,
    //   submenu: [
    //     {
    //       label: "Bulk Message",
    //       path: "/bulkMessage",
    //       arr: array[42] === 1,
    //     },
    //     {
    //       label: "RCS Standalone Msg",
    //       path: "/rcsstandalonemsg",
    //       arr: array[68] === 1,
    //     },
    //     {
    //       label: "RCS Plain Text",
    //       path: "/rcsplaintext",
    //       arr: array[69] === 1,
    //     },
    //     {
    //       label: "RCS Carousel",
    //       path: "/rcscarousel",
    //       arr: array[70] === 1,
    //     },
    //   ],
    // },
    {
      name: "Wallet",
      icon: WalletIcon,
      arr: array[0] === 1,
      submenu: [
        {
          label: "Purchase Credits",
          path: "/buysms",
          arr: array[22] === 1,
        },
        {
          label: "Top-Up SMS/RCS",
          path: "/walletActivity",
          arr: array[44] === 1,
        },
        {
          label: "Main Wallet",
          path: "/topUpMainWallet",
          arr: array[49] === 1,
        },
        {
          label: "Top-Up Wallet",
          path: "/topUpWallet",
          arr: array[134] === 1,
        },
      ],
    },
    {
      name: "Management",
      icon: ManageUserIcon,
      arr: array[0] === 1,
      submenu: [
        {
          label: "Menu Management",
          path: "/menuManagement",
          arr: array[28] === 1,
        },
      ],
    },
    {
      name: "Support Center",
      icon: SupportCenterIcon,
      arr: array[0] === 1,
      submenu: [
        {
          label: "Customer Enquiries",
          path: "/customerEnquiries",
          arr: array[75] === 1,
        },
        {
          label: "OTP Enquiries",
          path: "/otpEnquiries",
          arr: array[75] === 1 && canViewOtpEnquiries,
        },
      ],
    },
    {
      name: "Settings",
      icon: SettingIcon,
      arr: array[0] === 1,
      submenu: [
        {
          label: "Profile",
          path: "/settings",
          arr: array[29] === 1,
        },
      ],
    },
  ];

  const handleLogout = () => {
    try {
      setShowModal(false);
    } catch (error) {
      console.log("Something went wrong");
    }
  };

  const handleMenuClick = (menuName) => {
    setSelectedMenu(menuName);
  };

  const activeMenuItems = menuItems
    ?.map((item) => {
      if (item.arr) {
        const activeSubmenus = item.submenu
          ? item.submenu.filter((submenu) => submenu.arr)
          : [];

        // Hide main icon if no submenu is visible
        if (activeSubmenus.length === 0) return null;

        return { ...item, submenu: activeSubmenus };
      }
      return null;
    })
    .filter(Boolean);

  return (
    <>
      <div
        className="flex relative"
        onMouseLeave={() => dispatch(toggleSidebar())}
      >
        <div
          className={`w-[80px] h-[87vh] mt-2 flex flex-col justify-between pb-2 md:mt-0 bg-custom-gradient bg-[#FF702B] rounded-[17px] items-center z-10 overflow-auto custom-scrollbar`}
        >
          {/* Top section (menu items) */}
          <div className="w-full">
            <div className="w-[80px] h-[16px] rounded-t-[21px]"></div>
            {activeMenuItems.map((item, index) => {
              return (
                item.arr && (
                  <div
                    key={index}
                    className="flex group items-center justify-start gap-0 w-full border-b border-[#efeded]"
                  >
                    <div
                      className={`h-[60px] ${
                        selectedMenu === item.name
                          ? "bg-[#2E237F] w-1"
                          : "bg-transparent group-hover:bg-primary w-[2px]"
                      } rounded-sm`}
                    ></div>
                    <div className="flex flex-col items-center justify-center w-full py-2">
                      <div
                        className="h-[24px] w-[39px] flex items-center justify-center cursor-pointer"
                        onMouseEnter={() => {
                          setSelectedMenu(item.name);
                          dispatch(openSidebar());
                        }}
                      >
                        <img
                          src={item.icon}
                          alt="img"
                          className="h-[19px] w-[18px]"
                        />
                      </div>
                      <span className="text-white text-[10px] mt-1 font-medium text-center">
                        {item.name}
                      </span>
                    </div>
                  </div>
                )
              );
            })}
          </div>

          {/* Bottom (Logout) */}
          <div
            className="flex items-center justify-center w-[80px] h-[60px] rounded-b-[21px] cursor-pointer mb-2"
            onClick={() => setShowModal(true)}
          >
            <img src={LogoutIcon} alt="logout" className="w-12 h-10" />
          </div>
        </div>

        {/* White Sidebar while open */}
        <div
          className={`transition-all duration-300 ease-in-out mt-2 h-[87vh] ${
            isSidebarOpen ? "w-[211px]" : "w-0"
          } bg-[#FFFFFF] text-[#FFFFFF] rounded-3xl shadow-lg flex ${"flex-col"}`}
        >
          <div
            className={`flex flex-col items-center justify-center ${"mt-10"} gap-2 ${
              isSidebarOpen ? "w-auto" : "hidden"
            }`}
          >
          {/* Profile Icon with Green Dot for Online Status */}
            <div className="relative">
             <div className="w-[46px] h-[46px] rounded-full bg-gradient-to-tr from-orange-500 via-orange-400 to-amber-300 p-[2px] shadow-lg">
               <div className="w-full h-full rounded-full bg-white flex items-center justify-center">
                 <div className="w-[88%] h-[88%] rounded-full bg-gradient-to-br from-[#ff9a44] to-[#fc6076] flex items-center justify-center">
                   <span className="text-white text-base font-extrabold">
                     {getInitial(userData?.user?.data?.name ||
                        userData?.user?.data?.username
                     )}
                   </span>
                 </div>
               </div>
             </div>
           
             <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 border border-white rounded-full"></div>
           </div>

            <div className="text-center mt-2">
              <p className="!text-[#495057] text-sm font-semibold">
                Hello,{" "}
                <span className="text-orange-600">
                  {userData?.user?.data?.username}
                </span>
              </p>

              <p className="!text-[#495057] text-sm font-medium mt-1">
                Profile -{" "}
                <span className="text-gray-800">
                  {userData?.user?.data?.userProfile === "CUSTOMER"
                    ? "LMBP"
                    : userData?.user?.data?.userProfile
                        ?.charAt(0)
                        .toUpperCase() +
                      userData?.user?.data?.userProfile?.slice(1).toLowerCase()}
                </span>
              </p>

              {/* Hide Role section if userProfile is CUSTOMER */}
              {userData?.user?.data?.userProfile !== "CUSTOMER" && (
                <p className="!text-[#495057] text-sm font-medium mt-1">
                  Role -{" "}
                  <span className="text-gray-800">
                    {userData?.user?.data?.roleName}
                  </span>
                </p>
              )}
            </div>
          </div>
          <img
            src={SidebarBackIcon}
            alt="backIcon"
            className={`absolute  top-[122px] ${
              isSidebarOpen ? "right-[-25px]" : "right-[10px]"
            } cursor-pointer`}
            onClick={() => dispatch(toggleSidebar())}
          />

          <div className={`flex ${"mt-[20px]"}`}>
            {isSidebarOpen && (
              <div>
                {activeMenuItems.map((item) => {
                  return (
                    <div
                      key={item.name}
                      onClick={() => handleMenuClick(item.name)}
                    >
                      {selectedMenu === item.name && item.submenu && (
                        <MenuItem
                          title={item?.name}
                          items={item.submenu}
                          height="64%"
                          isSidebarOpen={isSidebarOpen}
                          icon={HomeMainIcon}
                        />
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
        <LogoutModal
          isOpen={showModal}
          onClose={handleLogout}
          setShowModal={setShowModal}
          handleLogout={handleLogout}
        />
      </div>
    </>
  );
};

export default NewSidebar;
